import React from 'react'
import { useEffect, useState } from "react";

import Label from 'lib/Label'
import "./index.scss"
import { Col } from 'react-bootstrap';
import ErrorMessage from 'lib/ErrorMessage';

const   TextArea = (props) => {
  const {
    placeholder,
    label,
    value,
    onChange,
    rows,
    cols,
    maxLength,
    className,
    label_style,
    name,
    size,
    validators,
    autofocus,
    isEditable, // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
  error,
  is_disabled,
  selectedData,
  default_value,
  disabled,
  onLoad
  } = props;
   const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : ""

  useEffect(() => {
    if (default_value) {
      onLoad(name, default_value);
    }
  }, [disabled]);
  
  return (
    <div className={size}>
      <Label label={label} className={label_style} validators={validators}/>
      <textarea
        name={name}
        placeholder={placeholder}
        autoFocus={autofocus? true: false}
        className={`form-textarea ${!isEditable && "radioDisabled"}  ${errorClass}`}
        value={value}
        onChange={onChange}
        rows={rows}
        cols={cols}
        maxLength={maxLength}
        disabled = {selectedData && eval(is_disabled) ? true: isEditable ? false:true}
      />
      { error?.length !== 0 && (
          <ErrorMessage error={error}/>
        )
      }
    </div>
  );
};

export default TextArea